import React from 'react';
import logo from './logo.svg';
import './App.css';
import BottomNav from './components/BottomNav.js';
import LoginPage from './components/LoginPage.js';
import HomePage from './components/HomePage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function AnnuairePage() {
  return <h1>Annuaire Page</h1>;
}

function ReservationsPage() {
  return <h1>Reservations Page</h1>;
}

function ClubsPage() {
  return <h1>Clubs Page</h1>;
}

function Logout() {
  localStorage.setItem('isAuthenticated', 'false');
  window.location.href = '/*';
}

function App() {
  //const isAuthenticated = localStorage.getItem('isAuthenticated');
  const isAuthenticated = true;

  return (
    <Router>
      <Routes>
        {isAuthenticated ? (
          <>
            <Route path="/" element={<HomePage />} />
            <Route path="/annuaire" element={<AnnuairePage />} />
            <Route path="/reservations" element={<ReservationsPage />} />
            <Route path="/clubs" element={<ClubsPage />} />
            <Route path="/logout" element={<Logout />} />
          </>
        ) : (
          <Route path="/*" element={<LoginPage />} />
        )}
      </Routes>
      {isAuthenticated && <BottomNav />}
    </Router>
  );
}

export default App;
